import $ from 'jquery'
import CategoryAndTagHeader from "./widgets/category-and-tag-header"
import Ranking from "./widgets/ranking";
import Header from "./widgets/header"
import NewHeader from "./widgets/new-header";
import domEvents from "./modules/dom-events";
import LoginButton from "./modules/login-button";
import VideoConsultas from "./widgets/video-consultas";
import AccountComplete from "./widgets/account-complete";

new Header();
new NewHeader();
domEvents.init();

$('[data-id="category_and_tag_header"]').each(function () {
    new CategoryAndTagHeader(this);
});

$('[data-id="c-ranking"]').each(function () {
    new Ranking(this);
});

$('[data-login-show]').each(function(){
    new LoginButton(this);
});

$('[data-account_complete-container]').each(function () {
    new AccountComplete(this);
});

new VideoConsultas($('[data-id="video-consulta-render"]'));